import styled from 'styled-components';

export const Image = styled.img`
  width: 251%;

  ${({ theme }) => theme.breakpoints.up('xs')} {
    width: 251%;
  }
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 167%;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 167%;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 125%;
  }
  ${({ theme }) => theme.breakpoints.up('xl')} {
    width: 100%;
  }
`;
